import React from 'react'
import './contactform.scss'
import { Row, Col, Button } from 'react-bootstrap'
import Form from 'react-bootstrap/Form';
import { Link } from 'react-router-dom';
const ContactForm = () => {
    return (
        <div className='bussiness_form contact_form'>
            <Row>
                <Col sm={12} md={8} lg={8} xl={8}>
                    <div className='common-heading'>
                        <h2>Let’s start the conversation.</h2>
                    </div>
                    <div className='text'>
                        <p>Want us to contact you? Fill out the form below and we’ll get back to you. If you’re a vendor looking for more information,
                            <Link to="">contact us.</Link></p>
                    </div>
                    <div className='talk-form-main'>
                        <div className='top-heading'>
                            <h4 className='sub_heading'>Tell us more about you</h4>
                        </div>
                        <Form>
                            <Row>
                                <Col sm={12} md={6} lg={6} xl={6}>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Name*</Form.Label>
                                        <Form.Control />
                                    </Form.Group>
                                </Col>
                                <Col sm={12} md={6} lg={6} xl={6}>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Company name</Form.Label>
                                        <Form.Control />
                                    </Form.Group>
                                </Col>
                                <Col sm={12} md={6} lg={6} xl={6}>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Phone*</Form.Label>
                                        <Form.Control />
                                    </Form.Group>
                                </Col>
                                <Col sm={12} md={6} lg={6} xl={6}>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control />
                                    </Form.Group>
                                </Col>
                                <div className='top-heading'>
                                    <h4 className='sub_heading'>How can we help you?
                                    </h4>
                                </div>
                                <Col sm={12} md={6} lg={6} xl={6}>
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Are you a current customer?</Form.Label>
                                        <Form.Check
                                            type='radio'
                                            id='default-radio'
                                            label='Yes'
                                            name='working'
                                        />
                                        <Form.Check
                                            type='radio'
                                            id='default-radio'
                                            label='No'
                                            name='working'

                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <div className='top-heading mt-5 '>
                                <h4 className='sub_heading '>Or tell us in your own words </h4>
                            </div>
                            <div className='term-condition  p-0'>
                                <p>Please don’t provide sensitive personal information (e.g., your Social Security number, date of birth, or driver’s license number). If we need additional information, we’ll contact you directly. Thank you.</p>
                            </div>
                                <Col sm={12} className='mb-3'>
                                    <Form.Group className="mb-0">
                                        <Form.Label>Comments</Form.Label>
                                        <Form.Control as="textarea" rows={7} className='mb-0' />
                                    </Form.Group>
                                </Col>
                            <div className='term-condition'>
                                <p>By pressing submit form, you agree that the information you are providing
                                     is your own and we may use the information you provide according to our <Link to="">Privacy Policy </Link> 
                                     and <Link to=""> Terms & Conditions.</Link></p>
                            </div>
                            <div className='bottom-btn'>
                                <Button className='submit-btn' type="submit">
                                Send
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Col>
                <Col sm={12} md={4} lg={4} xl={4}>

                </Col>
            </Row>
        </div>
    )
}

export default ContactForm;